var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tick"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.24965 10.5C5.10037 10.5 4.95115 10.443 4.83723 10.3291L2.5039 7.99572C2.27605 7.76787 2.27605 7.39874 2.5039 7.17083C2.73175 6.94292 3.10088 6.94298 3.32879 7.17083L5.2497 9.09175L10.6706 3.67089C10.8984 3.44304 11.2675 3.44304 11.4955 3.67089C11.7234 3.89874 11.7233 4.26787 11.4955 4.49578L5.66212 10.3291C5.5482 10.443 5.39886 10.5 5.24965 10.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.6b04ce28350a509445a31b722c1a99b7.svg";
export { ForwardRef as ReactComponent };